export function resolveSubmissionApproverId(item) {
  if (!item) return null;

  return item.approver_user_id === null
    ? item.user_id
    : item.approver_user_id;
}

export function resolveSubmissionApproverSelections(items) {
  return (Array.isArray(items) ? items : []).map(item =>
    resolveSubmissionApproverId(item)
  );
}
